import { PayCorrectionAdjustedEmployeeSalaries } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionAdjustedEmployeeSalaries';

export const getPayCorrectionAdjustedSalaryByEmployeeId = ({
  employeeid,
  adjustedSalaries,
  recommendedSalary,
}: {
  employeeid: string;
  adjustedSalaries: PayCorrectionAdjustedEmployeeSalaries;
  recommendedSalary: number;
}): number => {
  return adjustedSalaries[employeeid] ?? recommendedSalary;
};
